/* unplugin-vue-components disabled */import script from "./message-call-group.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-call-group.vue?vue&type=script&setup=true&lang=ts"

import "./message-call-group.vue?vue&type=style&index=0&id=4bbf77fc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bbf77fc"]])

export default __exports__